<template>
  <v-container fluid class="new-appraisal">
    <div class="new-appraisal-content" v-if="steps">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <template>
            <v-stepper-step
              v-for="n in steps"
              :key="`${n.step}-step`"
              :complete="e1 > n.step"
              :step="n.step"
            >
              {{ n.label }}
            </v-stepper-step>

            <v-divider v-if="n !== steps" :key="n"></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="n in steps"
            :key="`${n.step}-content`"
            :step="n.step"
          >
            <div class="content-step1" v-if="n.step == 1">
              <v-text-field
                v-model="step1.name"
                placeholder="Propietario"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.phone"
                placeholder="Telefono"
                type="number"
              ></v-text-field>
              <v-text-field
                v-model="step1.interesado"
                placeholder="V.Interesado"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.entrega"
                placeholder="Entrega inmediata"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.brand"
                placeholder="Marca"
                type="text"
              ></v-text-field>
            </div>
            <div class="content-step2" v-if="n.step == 2">
              <v-tabs v-model="tab" color="primary" grow>
                <v-tab v-for="item in tabItem" :key="item">
                  {{ item }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in tabItem" :key="item">
                  <v-card flat>
                    <v-row class="manual mt-5" v-if="item == 'Manual'">
                      <v-col cols="12">
                        <h3>Datos del vehículo</h3>
                        <v-simple-table>
                          <tbody>
                            <tr>
                              <td>
                                <v-text-field
                                  value="MARCA"
                                  type="text"
                                  disabled
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model="step2.brand"
                                  type="text"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <v-text-field
                                  value="MODELO"
                                  type="text"
                                  disabled
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model="step2.model"
                                  type="text"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <v-text-field
                                  value="MATRÍCULA"
                                  type="text"
                                  disabled
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model="step2.plate"
                                  type="text"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <v-text-field
                                  value="COLOR"
                                  type="text"
                                  disabled
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model="step2.color"
                                  type="text"
                                ></v-text-field>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <v-text-field
                                  value="KM"
                                  type="text"
                                  disabled
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model="step2.kilometers"
                                  type="text"
                                ></v-text-field>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <v-text-field
                                  value="MOTOR CV"
                                  type="text"
                                  disabled
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model="step2.engine"
                                  type="text"
                                ></v-text-field>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <v-text-field
                                  value="F.MATRICULACIÓN"
                                  type="text"
                                  disabled
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model="step2.year"
                                  type="text"
                                ></v-text-field>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <v-text-field
                                  value="ITV"
                                  type="text"
                                  disabled
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model="step2.itv"
                                  type="text"
                                ></v-text-field>
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-col>

                      <v-col cols="12">
                        <v-divider></v-divider>
                      </v-col>

                      <v-col cols="5">
                        <div class="mb-5">
                          <h3>Mecánica y Electricidad</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="MOTOR"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.motor"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.motor"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.motor"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="EMBRAGUE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.embrague"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.embrague"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.embrague"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="CAJA DE CAMBIOS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.cajadecambios"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.cajadecambios"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.cajadecambios"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="PUENTE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puente"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puente"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puente"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESCAPE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.escape"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.escape"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.escape"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="FRENOS (PASTILLAS)"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.frenos"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.frenos"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.frenos"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="FRENOS (DISCOS)"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.discos"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.discos"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.discos"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="SUSPENSIÓN DEL."
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.suspensionDel"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.suspensionDel"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.suspensionDel"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="SUSPENSIÓN TRAS."
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.suspensionTras"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.suspensionTras"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.suspensionTras"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="DIRECCIÓN"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.direccion"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.direccion"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.direccion"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="BATERÍA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.bateria"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.bateria"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.bateria"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ALTERNADOR"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.alternador"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.alternador"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.alternador"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ARRANQUE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.arranque"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.arranque"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.arranque"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="LUCES DELANTERAS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lucesDel"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lucesDel"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lucesDel"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="LUCES TRASERAS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lucesTras"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lucesTras"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lucesTras"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="CIERRE CENTRALIZADO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.cierrecentralizado"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.cierrecentralizado"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.cierrecentralizado"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ELEVALUNAS ELÉCTRICOS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.elevalunas"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.elevalunas"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.elevalunas"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ALARMA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.alarma"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.alarma"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.alarma"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="DIVERSOS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.diversos"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.diversos"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.diversos"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Interior</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESTADO VOLANTE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.volante"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.volante"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.volante"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESTADO TAPICERÍA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tapicería"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tapicería"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tapicería"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESTADO PEDALES"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.pedales"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.pedales"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.pedales"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="NAVEGADOR"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.navegador"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.navegador"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.navegador"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="CLIMATIZACIÓN A/C"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.climatizacion"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.climatizacion"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.climatizacion"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="CALEFACCIÓN"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.calefaccion"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.calefaccion"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.calefaccion"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Otros</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  SI
                                </th>
                                <th>
                                  NO
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="SEGUNDA LLAVE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.segundallave"
                                    color="green"
                                    value="SI"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.segundallave"
                                    color="red"
                                    value="NO"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="LIBRO DE MANTENIMIENTO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.librodemantenimiento"
                                    color="green"
                                    value="SI"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.librodemantenimiento"
                                    color="red"
                                    value="NO"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="VEHÍCULO DE IMPORTACIÓN"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.importacion"
                                    color="green"
                                    value="SI"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.importacion"
                                    color="red"
                                    value="NO"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="SEGURO T.RIESGO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.todoriesgo"
                                    color="green"
                                    value="SI"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.todoriesgo"
                                    color="red"
                                    value="NO"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="SEGURO T.RIESGO FRANQUICIA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.todoriesgoFranquicia"
                                    color="green"
                                    value="SI"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.todoriesgoFranquicia"
                                    color="red"
                                    value="NO"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="SEGURO BÁSICO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.segurobasico"
                                    color="green"
                                    value="SI"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.segurobasico"
                                    color="red"
                                    value="NO"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="PARTES QUE ENTREGA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.partes"
                                    color="green"
                                    value="SI"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.partes"
                                    color="red"
                                    value="NO"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>
                      </v-col>
                      <v-col cols="2" class="d-flex justify-center">
                        <v-divider vertical></v-divider>
                      </v-col>
                      <v-col cols="5">
                        <div class="mb-5">
                          <h3>Exterior</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="PUERTA DD"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaDD"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaDD"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaDD"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="PUERTA DI"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaDI"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaDI"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaDI"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="PUERTA TD"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaTD"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaTD"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaTD"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="PUERTA TI"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaTI"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaTI"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.puertaTI"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="TECHO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.techo"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.techo"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.techo"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="PARTE DELANTERA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.delantera"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.delantera"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.delantera"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="PARTE TRASERA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.trasera"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.trasera"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.trasera"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="CAPÓ"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.capo"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.capo"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.capo"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="MALETERO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.maletero"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.maletero"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.maletero"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ALETA DD"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaDD"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaDD"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaDD"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ALETA DI"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaDI"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaDI"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaDI"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ALETA TD"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaTD"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaTD"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaTD"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ALETA TI"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaTI"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaTI"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.aletaTI"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="PINTURA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.pintura"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.pintura"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.pintura"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="GOLPES EN CARROCERÍA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.golpes"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.golpes"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.golpes"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESPEJOS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.espejos"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.espejos"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.espejos"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="LUNAS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lunas"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lunas"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.lunas"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Neumáticos</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="LLANTAS DEL."
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.llantasDel"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.llantasDel"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.llantasDel"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="LLANTAS TRAS."
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.llantasTras"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.llantasTras"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.llantasTras"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="RUEDAS DEL."
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedasDel"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedasDel"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedasDel"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="RUEDAS TRAS."
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedasTras"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedasTras"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedasTras"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="RUEDA REPUESTO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedarepuesto"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedarepuesto"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.ruedarepuesto"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Posibles averías</h3>
                          <v-textarea
                            v-model="step2.averias"
                            background-color="amber lighten-4"
                            color="orange orange-darken-4"
                          ></v-textarea>
                        </div>

                        <div class="mt-5">
                          <h3>Imágenes</h3>
                          <v-file-input
                            class="mt-5"
                            v-model="images"
                            color="primary"
                            counter
                            multiple
                            placeholder="Imágenes del vehículo"
                            prepend-icon="mdi-paperclip"
                            outlined
                            :show-size="1000"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="primary"
                                dark
                                label
                                small
                              >
                                {{ text }}
                              </v-chip>

                              <span
                                v-else-if="index === 2"
                                class="text-overline grey--text text--darken-3 mx-2"
                              >
                                +{{ images.length - 2 }} Archivo(s)
                              </span>
                            </template>
                          </v-file-input>
                        </div>
                      </v-col>
                    </v-row>
                    <div class="automatico" v-else>
                      Automatico
                    </div>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>

            <v-btn color="primary" @click="nextStep(n.step)">
              GUARDAR
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { postMethodToken, postMethodTokenImage } from "@/api-consume/api-calls";
import store from "@/store/index";
export default {
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: 3000,
      snackbarColor: "",
      tab: null,
      tabItem: ["Manual", "Automático"],
      e1: 1,
      steps: [
        { label: "Datos de cliente", step: 1 },
        { label: "Datos de vehículo", step: 2 }
      ],
      step1: {
        name: "",
        phone: "",
        interesado: "",
        commercial_user_id: store.state.userLogged.user_id,
        entrega: "",
        brand: ""
      },
      step2: {
        brand: "",
        model: "",
        plate: "",
        color: "",
        kilometers: "",
        engine: "",
        year: "",
        itv: "",
        motor: "",
        embrague: "",
        cajadecambios: "",
        puente: "",
        escape: "",
        frenos: "",
        discos: "",
        suspensionDel: "",
        suspensionTras: "",
        direccion: "",
        bateria: "",
        alternador: "",
        arranque: "",
        lucesDel: "",
        lucesTras: "",
        cierrecentralizado: "",
        elevalunas: "",
        alarma: "",
        diversos: "",
        volante: "",
        tapicería: "",
        pedales: "",
        navegador: "",
        climatizacion: "",
        calefaccion: "",
        segundallave: "",
        librodemantenimiento: "",
        importacion: "",
        todoriesgo: "",
        todoriesgoFranquicia: "",
        segurobasico: "",
        partes: "",
        puertaDD: "",
        puertaDI: "",
        puertaTD: "",
        puertaTI: "",
        techo: "",
        delantera: "",
        trasera: "",
        capo: "",
        maletero: "",
        aletaDD: "",
        aletaDI: "",
        aletaTD: "",
        aletaTI: "",
        pintura: "",
        golpes: "",
        espejos: "",
        lunas: "",
        llantasDel: "",
        llantasTras: "",
        ruedasDel: "",
        ruedasTras: "",
        ruedarepuesto: "",
        averias: ""
      },
      images: [],
      responseId: ""
    };
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    }
  },

  methods: {
    async nextStep(n) {
      var options = {};
      var flag = true;
      switch (n) {
        case 1:
          var check = Object.values(this.step1).includes("");
          if (check) {
            this.snackbar = true;
            this.snackbarText = "Complete todos los campos.";
            this.snackbarColor = "red";
            flag = false;
          }
          options = this.step1;
          options.step_1 = 1;
          break;
        case 2:
          options = this.step2;
          options.step_2 = 1;
          options.id = this.responseId;
          break;

        default:
          break;
      }

      if (flag) {
        console.log("ENVÍO: ", options);
        const response = await postMethodToken(
          "/api/appraisal/create",
          options
        );
        console.log("CREAR TASACIÓN: ", response);

        if (response.status == 200) {
          this.responseId = response.data.payload.appraisal.id;
          if (n == 2) {
            console.log("ENVÍO IMAGES: ", this.responseId, this.images);
            for (let x = 0; x < this.images.length; x++) {
              const resp = await postMethodTokenImage(
                "/api/appraisal/images/upload",
                this.responseId,
                this.images[x]
              );
              console.log("SUBIR IMAGENES: ", resp);
              if (resp.status != 200) {
                this.snackbar = true;
                this.snackbarText = "Error al guardar las imágenes.";
                this.snackbarColor = "red";
                return 0;
              }
            }
          }
          if (n === this.steps.step) {
            this.e1 = 1;
          } else {
            this.e1 = n + 1;
          }
        } else {
          this.snackbar = true;
          this.snackbarText = "Error al crear la tasación.";
          this.snackbarColor = "red";
        }
      }
    }
  }
};
</script>
